export default function Footer() {
  return (
    <footer className="hidden min-h-6 w-full flex-wrap items-center justify-between gap-x-6 bg-[#333333] px-4 sm:flex md:px-6 xl:px-20">
      <div className="flex min-w-0 items-center">
        <a
          href="https://fieldtomarketca.github.io/FieldprintCalculator_Client/"
          className="text-white no-underline text-[11px] hover:underline "
        >
          Data and Privacy Policy
        </a>
        <p className="text-white mx-2">|</p>
        <a
          href="https://fieldtomarketca.github.io/FieldprintCalculator_Client/"
          className="text-white no-underline text-[11px] hover:underline "
        >
          Terms of Use
        </a>
      </div>
      <div className="flex min-w-0 items-center">
        <a
          href="https://fieldtomarketca.github.io/FieldprintCalculator_Client/"
          className="text-white no-underline text-[11px] hover:underline "
        >
          membership@fieldtomarket.ca
        </a>
        <p className="text-white mx-2">|</p>
        <a
          href="https://fieldtomarketca.github.io/FieldprintCalculator_Client/"
          className="text-white no-underline text-[11px] hover:underline "
        >
          www.fieldtomarket.ca
        </a>
      </div>
    </footer>
  );
}
